import { useEffect, useRef, useState } from "react";

function elementOrAncestorHasClass(el: Element | null, className: string): boolean {
  let current: Element | null = el;
  while (current) {
    if (current.classList.contains(className)) {
      return true;
    }
    current = current.parentElement;
  }
  return false;
}

export function useHasAncestorClass(className: string) {
  const ref = useRef<HTMLDivElement>(null);
  const [hasClass, setHasClass] = useState(false);

  useEffect(() => {
    setHasClass(elementOrAncestorHasClass(ref.current, className));
  });

  return { ref, hasClass };
}

export function useGetWidthCategory() {
  const ref = useRef<HTMLDivElement>(null);
  const [hasXS, setHasXS] = useState(false);
  const [hasSM, setHasSM] = useState(false);
  const [hasMD, setHasMD] = useState(false);
  const [hasLG, setHasLG] = useState(false);

  useEffect(() => {
    setHasXS(elementOrAncestorHasClass(ref.current, "xs"));
    setHasSM(elementOrAncestorHasClass(ref.current, "sm"));
    setHasMD(elementOrAncestorHasClass(ref.current, "md"));
    setHasLG(elementOrAncestorHasClass(ref.current, "lg"));
  });

  let widthCategory: "xs" | "sm" | "md" | "lg" = "lg";
  if (hasXS) {
    widthCategory = "xs";
  } else if (hasSM) {
    widthCategory = "sm";
  } else if (hasMD) {
    widthCategory = "md";
  } else if (hasLG) {
    widthCategory = "lg";
  } else {
    const width = window.innerWidth;
    if (width >= 1024) {
      widthCategory = "lg";
    } else if (width >= 768) {
      widthCategory = "md";
    } else if (width >= 512) {
      widthCategory = "sm";
    } else {
      widthCategory = "xs";
    }
  }

  return { ref, widthCategory };
}